"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingBlock = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("../../basics/Button"));
var typography_1 = require("../../typography");
var Images_1 = require("../Images");
var styles_1 = require("./styles");
var MarketingBlock = function (_a) {
    var title = _a.title, _b = _a.color, color = _b === void 0 ? 'blue' : _b, button = _a.button, border = _a.border, backgroundImageUrl = _a.backgroundImageUrl, backgroundImageOptions = _a.backgroundImageOptions, backgroundImageLazy = _a.backgroundImageLazy, _c = _a.titleMaxWidth, titleMaxWidth = _c === void 0 ? 20 : _c, commonProps = __rest(_a, ["title", "color", "button", "border", "backgroundImageUrl", "backgroundImageOptions", "backgroundImageLazy", "titleMaxWidth"]);
    var imgConfig = react_1.default.useMemo(function () {
        return Images_1.getImgProps(backgroundImageUrl, {
            small: 100,
            medium: 100,
            large: 100,
            xlarge: 100,
        }, backgroundImageOptions);
    }, [backgroundImageUrl, backgroundImageOptions]);
    return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "MarketingBlock" }, commonProps, { "$backgroundColor": color, "$border": border }),
        react_1.default.createElement(styles_1.Img, __assign({}, imgConfig, { fit: "cover", lazy: backgroundImageLazy, backgroundColor: styles_1.BACKGROUND_COLOR[color], position: "center left" })),
        react_1.default.createElement(styles_1.ContentWrapper, null,
            react_1.default.createElement(typography_1.Heading, { level: "3", color: "BLUE_50", maxWidth: titleMaxWidth }, title),
            react_1.default.createElement(Button_1.default, __assign({}, button)))));
};
exports.MarketingBlock = MarketingBlock;
exports.default = exports.MarketingBlock;
